/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DefinitionParameterValueSetDto } from './DefinitionParameterValueSetDto';
import {
    DefinitionParameterValueSetDtoFromJSON,
    DefinitionParameterValueSetDtoFromJSONTyped,
    DefinitionParameterValueSetDtoToJSON,
} from './DefinitionParameterValueSetDto';
import type { DefinitionParameterDto } from './DefinitionParameterDto';
import {
    DefinitionParameterDtoFromJSON,
    DefinitionParameterDtoFromJSONTyped,
    DefinitionParameterDtoToJSON,
} from './DefinitionParameterDto';
import type { CreateDefinitionDtoValueType } from './CreateDefinitionDtoValueType';
import {
    CreateDefinitionDtoValueTypeFromJSON,
    CreateDefinitionDtoValueTypeFromJSONTyped,
    CreateDefinitionDtoValueTypeToJSON,
} from './CreateDefinitionDtoValueType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { CreateDefinitionDtoDefinitionLabel } from './CreateDefinitionDtoDefinitionLabel';
import {
    CreateDefinitionDtoDefinitionLabelFromJSON,
    CreateDefinitionDtoDefinitionLabelFromJSONTyped,
    CreateDefinitionDtoDefinitionLabelToJSON,
} from './CreateDefinitionDtoDefinitionLabel';

/**
 * 
 * @export
 * @interface DefinitionDto
 */
export interface DefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof DefinitionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DefinitionDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DefinitionDto
     */
    description?: string | null;
    /**
     * 
     * @type {CreateDefinitionDtoValueType}
     * @memberof DefinitionDto
     */
    valueType?: CreateDefinitionDtoValueType | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof DefinitionDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<DefinitionParameterDto>}
     * @memberof DefinitionDto
     */
    definitionParameters?: Array<DefinitionParameterDto> | null;
    /**
     * 
     * @type {Array<DefinitionParameterValueSetDto>}
     * @memberof DefinitionDto
     */
    definitionParameterValueSets?: Array<DefinitionParameterValueSetDto> | null;
    /**
     * 
     * @type {CreateDefinitionDtoDefinitionLabel}
     * @memberof DefinitionDto
     */
    definitionLabel?: CreateDefinitionDtoDefinitionLabel | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionDto
     */
    unitId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionDto
     */
    protocolId?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof DefinitionDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof DefinitionDto
     */
    $type?: DefinitionDtoTypeEnum;
}


/**
 * @export
 */
export const DefinitionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDefinitionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DefinitionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DefinitionDtoTypeEnum = typeof DefinitionDtoTypeEnum[keyof typeof DefinitionDtoTypeEnum];



/**
 * Check if a given object implements the DefinitionDto interface.
 */
export function instanceOfDefinitionDto(value?: unknown): value is DefinitionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DefinitionDtoTypeEnum)[0];
}

export function DefinitionDtoFromJSON(json: any): DefinitionDto {
    return DefinitionDtoFromJSONTyped(json, false);
}

export function DefinitionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'valueType': json['valueType'] == null ? undefined : CreateDefinitionDtoValueTypeFromJSON(json['valueType']),
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'definitionParameters': json['definitionParameters'] == null ? undefined : ((json['definitionParameters'] as Array<any>).map(DefinitionParameterDtoFromJSON)),
        'definitionParameterValueSets': json['definitionParameterValueSets'] == null ? undefined : ((json['definitionParameterValueSets'] as Array<any>).map(DefinitionParameterValueSetDtoFromJSON)),
        'definitionLabel': json['definitionLabel'] == null ? undefined : CreateDefinitionDtoDefinitionLabelFromJSON(json['definitionLabel']),
        'unitId': json['unitId'] == null ? undefined : json['unitId'],
        'unitAbbreviation': json['unitAbbreviation'] == null ? undefined : json['unitAbbreviation'],
        'protocolId': json['protocolId'] == null ? undefined : json['protocolId'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DefinitionDtoToJSON(value?: DefinitionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'valueType': CreateDefinitionDtoValueTypeToJSON(value['valueType']),
        'origin': EntityOriginToJSON(value['origin']),
        'definitionParameters': value['definitionParameters'] == null ? undefined : ((value['definitionParameters'] as Array<any>).map(DefinitionParameterDtoToJSON)),
        'definitionParameterValueSets': value['definitionParameterValueSets'] == null ? undefined : ((value['definitionParameterValueSets'] as Array<any>).map(DefinitionParameterValueSetDtoToJSON)),
        'definitionLabel': CreateDefinitionDtoDefinitionLabelToJSON(value['definitionLabel']),
        'unitId': value['unitId'],
        'unitAbbreviation': value['unitAbbreviation'],
        'protocolId': value['protocolId'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        '$type': value['$type'],
    });
}

